import { useCallback } from 'react';
import { useQuery } from 'react-query';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import { request } from '@/utils';

import { RestrictionRecord } from './types';

export const useRestrictionRecords = (id: string) => {
  const url = '/user/restrictions';
  const { t } = useTranslation();

  const select = useCallback(
    (res: { restrictions: RestrictionRecord[] }) => {
      res.restrictions.forEach(x => {
        x._duration = t('RestrictionRecords.duration', { count: x.duration });
        x._createAt = dayjs.unix(x.create_at).format('YYYY/MM/DD HH:mm');
      });

      return res.restrictions;
    },
    [t],
  );

  return useQuery(
    [url, id],
    () =>
      request.get<{
        restrictions: RestrictionRecord[];
      }>(url, { id }),
    {
      select,
      enabled: !!id,
    },
  );
};

type UserRestrictedRes = {
  is_restricted: boolean;
  end_at: number;
  _endAt: string;
};

export const useUserRestricted = (id: string) => {
  const url = '/user/check_restricted';

  const select = useCallback((res: UserRestrictedRes) => {
    res._endAt = dayjs.duration(res.end_at - Date.now() / 1000, 'seconds').humanize();

    return res;
  }, []);

  const queries = useQuery(
    [url, id],
    () =>
      request.get<UserRestrictedRes>(url, {
        id,
      }),
    {
      retry: false,
      select,
    },
  );

  return queries;
};
